/**
 * SSR/React-Native-safe accessors for browser globals.
 *
 * DBBL is consumed by azul (web), atlas (React Native), and server-rendered
 * contexts, so `window`/`document` may be undefined. These helpers guard access
 * so web-only effects can no-op outside the browser.
 */

export type DocumentLike = {
  documentElement: { dataset: Record<string, string> };
};

export type MatchMediaWindow = {
  matchMedia: (query: string) => { matches: boolean };
};

export const getDocument = (): DocumentLike | undefined => {
  const g = globalThis as { document?: DocumentLike };
  return typeof g.document === "undefined" ? undefined : g.document;
};

export const getMatchMediaWindow = (): MatchMediaWindow | undefined => {
  const g = globalThis as { window?: { matchMedia?: unknown } };
  if (
    typeof g.window === "undefined" ||
    typeof g.window.matchMedia !== "function"
  ) {
    return undefined;
  }
  return g.window as MatchMediaWindow;
};
